import { UUID } from "crypto";
import { baseApi } from "./baseApi";
import {
    AdditionalGuarantee,
    NewLinkPTSAV,
    Person,
    PersonEconomicEvaluation,
    PersonEmployment,
} from "@interfaces/persons";
import { Response, ResponsePagination } from "@interfaces/response";

import PersonasData from "../dataDummy/personas.json";

const personsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getPersons: build.query<Array<Person>, string>({
            // query: (params) => ({
            //     url: `personas?${params}`,
            // }),
            // transformResponse: (response: ResponsePagination<Person>) => {
            //     return response.data.data;
            // },

            async queryFn(args, _queryApi, _extraOptions, baseQuery) {
                if (args.includes("3912e960-7795-434f-bc47-d277ff43937e")) {
                    return {
                        data: PersonasData.data,
                    };
                }
                const result = await baseQuery({
                    url: `personas?${args}`,
                });

                return result.data.data;
            },
        }),
        postPerson: build.mutation<Person, Partial<Person>>({
            invalidatesTags: ["Application"],
            query: (data) => ({
                url: "personas",
                method: "POST",
                body: data,
            }),
            transformResponse: (response: Response<Person>) => {
                return response.data;
            },
        }),
        getPerson: build.query<Person, UUID>({
            query: (personId) => ({
                url: `personas/${personId}`,
            }),
            transformResponse: (response: Response<Person>) => {
                return response.data;
            },
        }),
        patchPerson: build.mutation<any, { personId: UUID; body: Partial<Person> }>({
            invalidatesTags: ["Application"],
            query: ({ personId, body }) => ({
                url: `personas/${personId}`,
                method: "PATCH",
                body,
            }),
        }),
        deletePerson: build.mutation<any, UUID | string>({
            invalidatesTags: ["Application"],
            query: (personId) => ({
                url: `personas/${personId}`,
                method: "DELETE",
            }),
        }),
        getNewMajorityShareholder: build.query<any, UUID>({
            query: (personId) => ({
                url: `personas/${personId}/cambiar_accionista_mayoritario`,
            }),
        }),
        postAdditionalGuarantee: build.mutation<any, AdditionalGuarantee>({
            query: (additionalGuarante) => ({
                url: "personas/aval_adicional",
                method: "POST",
                body: additionalGuarante,
            }),
        }),
        postNewLinkAdditionalGuarantee: build.mutation<NewLinkPTSAV, Partial<AdditionalGuarantee>>({
            query: (additionalGuarante) => ({
                url: "personas/aval_adicional/regenerar_liga",
                method: "POST",
                body: additionalGuarante,
            }),
            transformResponse: (response: Response<NewLinkPTSAV>) => {
                return response.data;
            },
        }),
        getPersonEconomicEvaluation: build.query<PersonEconomicEvaluation | undefined, UUID>({
            query: (personId) => ({
                url: `personas/${personId}/economic_evaluation`,
            }),
            transformResponse: (response: Response<Array<PersonEconomicEvaluation>>) => {
                return response.data.at(0);
            },
        }),
        postPersonEconomicEvaluation: build.mutation<PersonEconomicEvaluation, { personId: UUID; body: any }>({
            query: ({ personId, body }) => ({
                url: `personas/${personId}/economic_evaluation`,
                method: "POST",
                body,
            }),
            transformResponse: (response: Response<PersonEconomicEvaluation>) => {
                return response.data;
            },
        }),
        patchPersonEconomicEvaluation: build.mutation<PersonEconomicEvaluation, { personId: UUID; body: any }>({
            query: ({ personId, body }) => ({
                url: `personas/${personId}/economic_evaluation`,
                method: "PATCH",
                body,
            }),
            transformResponse: (response: Response<PersonEconomicEvaluation>) => {
                return response.data;
            },
        }),
        getPersonEmployment: build.query<PersonEmployment | undefined, UUID>({
            query: (personId) => ({
                url: `personas/${personId}/employment`,
            }),
            transformResponse: (response: Response<Array<PersonEmployment>>) => {
                return response.data.at(0);
            },
        }),
        postPersonEmployment: build.mutation<PersonEmployment, { personId: UUID; body: any }>({
            query: ({ personId, body }) => ({
                url: `personas/${personId}/employment`,
                method: "POST",
                body,
            }),
            transformResponse: (response: Response<PersonEmployment>) => {
                return response.data;
            },
        }),
        patchPersonEmployment: build.mutation<PersonEmployment, { personId: UUID; employmentId: UUID; body: any }>({
            query: ({ personId, employmentId, body }) => ({
                url: `personas/${personId}/employment/${employmentId}`,
                method: "PATCH",
                body,
            }),
            transformResponse: (response: Response<PersonEmployment>) => {
                return response.data;
            },
        }),
        postCreditBureauLink: build.mutation<Person, AdditionalGuarantee>({
            query: (body) => ({
                url: "personas/consulta_buro",
                method: "POST",
                body,
            }),
            transformResponse: (response: Response<Person>) => {
                return response.data;
            },
        }),
    }),
});

export const {
    useGetPersonsQuery,
    useLazyGetPersonsQuery,
    usePostPersonMutation,
    usePatchPersonMutation,
    useDeletePersonMutation,
    useLazyGetPersonQuery,
    useLazyGetNewMajorityShareholderQuery,
    usePostAdditionalGuaranteeMutation,
    usePostNewLinkAdditionalGuaranteeMutation,
    useLazyGetPersonEconomicEvaluationQuery,
    usePostPersonEconomicEvaluationMutation,
    usePatchPersonEconomicEvaluationMutation,
    useLazyGetPersonEmploymentQuery,
    usePostPersonEmploymentMutation,
    usePatchPersonEmploymentMutation,
    usePostCreditBureauLinkMutation,
} = personsApi;
